module.exports = __webpack_public_path__ + "static/quem_somos-1f4a121f632801832ecf2c73d72d4f91.png";